import { render, staticRenderFns } from "./ApiResultsPreview.vue?vue&type=template&id=6b796334&"
import script from "./ApiResultsPreview.vue?vue&type=script&lang=ts&"
export * from "./ApiResultsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports